import { FeatureAction } from '../actions/featureActions';
import { FeatureFlags } from '../models/featureFlags';

export const featureFlagsReducer = (featureFlags: FeatureFlags, action: FeatureAction): FeatureFlags => {
    switch (action.type) {
        case 'SET_CHAT_FEATURES':
            return { 
                ...featureFlags, 
                chat: {
                    conversation: action.payload.conversation,
                    personalGpt: action.payload.personalGpt,
                    speechToText: action.payload.speechToText,
                    isAdmin: action.payload.isAdmin, // Include isAdmin in the chat feature flags
                }
            };
        default:
            return featureFlags;
    }
};
